let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ZLgJ")).then(() => parcelRequire('8a0L7'));